import { render } from "./sidepane-communication.vue?vue&type=template&id=cccc4e8e&scoped=true"
import script from "./sidepane-communication.vue?vue&type=script&lang=js"
export * from "./sidepane-communication.vue?vue&type=script&lang=js"

import "./sidepane-communication.vue?vue&type=style&index=0&id=cccc4e8e&scoped=true&lang=scss"

import exportComponent from "../../../../../../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cccc4e8e"]])

export default __exports__